import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "taxId" }, [
    _c(
      "div",
      { staticClass: "tax-input" },
      [
        _c(VTextField, {
          staticClass: "flex-column",
          attrs: {
            mask: _vm.taxFormat.format,
            rules: _vm.rules,
            label: _vm.label,
            hint: _vm.hint,
            "persistent-hint": _vm.persistentHint,
            "return-masked-value": _vm.taxFormat.returnMaskedValue,
            "validate-on-blur": "",
            required: _vm.required,
          },
          on: {
            input: function ($event) {
              return _vm.emitValue()
            },
            blur: _vm.handleBlur,
          },
          model: {
            value: _vm.model,
            callback: function ($$v) {
              _vm.model = $$v
            },
            expression: "model",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }